import script from "./cart-item-count.vue?vue&type=script&setup=true&lang=ts"
export * from "./cart-item-count.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__